/**
 * Guest (exploration) mode — in-memory only, never persisted.
 *
 * PrivateRoute enables it when someone opens /dashboard without a session,
 * so the app is explorable read-only. Any API write while in guest mode is
 * intercepted in config/api.js and prompts to log in / create an account.
 *
 * Kept dependency-free on purpose: both authService and config/api import
 * from here, and either of them importing the other is a module cycle.
 */
let guest = false;

export const isGuest = () => guest;
export const setGuest = (value) => { guest = !!value; };

/**
 * Call before an API write. Returns true when the write must be BLOCKED
 * (guest mode): shows the login/register prompt and, if accepted, leaves
 * guest mode and navigates to the login screen.
 */
export const blockGuestWrite = () => {
  if (!guest) return false;
  if (window.confirm('Esta acción guarda información y necesita una cuenta.\n¿Quieres iniciar sesión o crear una gratis?')) {
    guest = false;
    window.location.assign('/auth/login');
  }
  return true;
};

/** Error thrown/rejected for a blocked guest write — services surface .message. */
export const guestBlockedError = () => {
  const err = new Error('Disponible con cuenta — inicia sesión para guardar.');
  err.isGuestBlocked = true;
  return err;
};
